<template>
  <div class="mainContainer">
    <div class="row align-center">
      <div class="col-12 col-lg-6 mainPurple p-5">
        <!--Logo & Registration-->
        <div class="row m-2">
          <div class="col-12">
            <transition name="fadeFast">
              <div
                v-show="error.show"
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                <strong>Hiba!</strong> {{ error.message }}
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            </transition>
          </div>
        </div>
        <div class="row mt-2 mt-md-5">
          <div class="col-6 col-md-4 offset-md-2">
            <img
              :src="
                require('@/assets/img/logo_e-egyetem_classroom_logo_white.png')
              "
              alt="classroom"
              class="img-fluid blaLoginLogo"
            />
          </div>
          <!-- <div class="col-6 col-md-4 p-2 blaLoginRegTitle clickable">
            Nincs még fiókod? <br />
            <a
              href="javascript:void(0)"
              @click="$router.push({ name: 'registration' })"
              >Regisztrálás</a
            >
          </div> -->
        </div>
        <div class="row">
          <div class="col-12 blaLoginTitle">
            Bejelentkezés
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-12 pt-5">
            <form>
              <div class="form-row align-items-center">
                <div class="col-12 col-md-8 offset-md-2 mx-auto">
                  <label class="sr-only" for="email">Email</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-user"></i>
                      </div>
                    </div>
                    <input
                      type="text"
                      class="form-control form-control-lg"
                      id="email"
                      placeholder="Email"
                      v-model="formLogin.email"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12 pt-4">
            <form>
              <div class="form-row align-items-center">
                <div class="col-12 col-md-8 offset-md-2 mx-auto">
                  <label class="sr-only" for="password">Jelszó</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-lock"></i>
                      </div>
                    </div>
                    <input
                      type="password"
                      class="form-control form-control-lg"
                      id="password"
                      placeholder="Jelszó"
                      v-model="formLogin.password"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="col-12 col-md-10 pt-4 text-right blaLoginLostPassword clickable"
            @click="$router.push({ name: 'PasswordReset' })"
          >
            Elfelejtettem a
            <strong>
              Jelszavam
            </strong>
          </div>
          <div class="col-12 pt-4 text-center">
            <div
              class="clickable mt-3 blaPrimaryButton text-center py-3 justify-center pl-50"
              @click="logIn"
            >
              <span class="px-3 py-3">
                Bejelentkezés
              </span>
            </div>
          </div>
          <div
            class="col-12 text-center clickable blaLoginOtherServiceContainer"
          >
            <div class="blaLoginSubTitle">
              <!--Bejelentkezés-->
            </div>
            <div class="blaLoginSubAlt">
              <!--Skillers rendszerbe-->
            </div>
            <div class="blaLoginSubTitle mt-5">
              <!--Bejelentkezés-->
            </div>
            <div class="blaLoginSubAlt">
              <!--e-Egyetem oktatási rendszerbe <br />-->
              <!--(csak régi felhasználók számára elérhető)-->
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 p-5 text-center blaLoginImage">
        <img
          :src="require('@/assets/img/login.png')"
          alt="login"
          class="img-fluid"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../assets/css/bla_style.css";
</style>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    error: {
      show: false,
      message: "",
      timeout: 4500
    },
    rules: {
      required: value => !!value || "Kötelező"
    },
    loader: false,
    chooser: false,
    login: true,
    registration: false,
    formLogin: {
      email: "",
      password: "",
      remember: ""
    }
  }),
  methods: {
    logIn() {
      this.$store.dispatch("login");

      this.$data.login = false;
      this.$data.loader = true;

      axios
        .post(this.$store.getters.getApiUrl + "/api/login", {
          email: this.$data.formLogin.email,
          password: this.$data.formLogin.password
        })
        .then(response => {
          if (response.data.token.length > 0) {
            this.$store.commit("loginSuccess", {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser
            });

            this.$store.commit("setIsAppState", {
              isApp: false
            });

            //Automaticaly save the email & pwd
            // if( this.$data.formLogin.remember === true )
            // {
            localStorage.loginEmail = this.$data.formLogin.email;
            localStorage.loginPassword = this.$data.formLogin.password;
            // }

            var v = this;

            setTimeout(function() {
              v.$data.loader = false;
              v.$router.push({ path: "/chooser" });
            }, 2000);
          }
        })
        .catch(error => {
          // console.log('error', error.response.data);

          var v = this;

          setTimeout(function() {
            v.$data.loader = false;
            v.$data.login = true;
            v.$data.error.message = "Hibás email vagy jelszó!";
            v.$data.error.code = error.response.data.code;
            v.$data.error.show = true;
          }, 2500);

          v.$data.error.show = false;
        });
    },
    goToSkillers() {
      window.location.href = "https://skillers.hu/web/app";
    }
  }
};
</script>
